import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import {
  Button,
  Swipe,
  SwipeItem,
  Field,
  Card,
  Icon,
  Tab,
  Tabs,
  Image as VanImage,
  Lazyload,
  Toast,
  Empty,
  Loading,
  Skeleton,
  Overlay,
  FloatingBubble,
  Dialog
} from "vant";
import "vant/lib/index.css";
import ChangeRem from "./utils/rem";
import VConsole from 'vconsole';
// const vConsole = new VConsole({ theme: 'dark' });


const app = createApp(App);

app.config.ChangeRem = ChangeRem;

app.use(Button);
app.use(Swipe);
app.use(SwipeItem);
app.use(router);
app.use(Field);
app.use(Card);
app.use(Icon);
app.use(Tab);
app.use(Tabs);
app.use(VanImage);
app.use(Lazyload);
app.use(Toast);
app.use(Empty);
app.use(Loading);
app.use(Skeleton);
app.use(Overlay);
app.use(FloatingBubble);
app.use(Dialog);
app.mount("#app");
